import { isNullOrUndefined } from 'util';
import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
// import Swal from 'sweetalert2';
import { UserManagementService } from 'src/app/services/user-management.service';
import { EncdecService } from 'src/app/services/encdec.service';
import { ConstantsModule } from 'src/app/common/constants/constants.module';
import { AuthloginService } from 'src/app/services/login/authlogin.service';
import { SubmitdataService } from 'src/app/services/submitdata/submitdata.service';
import { UtilsModule } from 'src/app/common/utils/utils.module';
import { isEmpty } from 'rxjs/operators';


@Component({
  selector: 'app-profile-form',
  templateUrl: './profile-form.component.html',
  styleUrls: ['./profile-form.component.css']
})
export class ProfileFormComponent implements OnInit {
  userdetails = {};
  userData = {name :'',mobilenum:'',email:'',districtname :''};
  validation : object = {name : true,mobilenum:true,email:true};
  districtEntityName: any;
  status: any = {};

  constructor(
    private userService: UserManagementService,
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private activeModal: NgbActiveModal,
    private toastrService: ToastrService,
    private encdecservice : EncdecService,
    private constant : ConstantsModule,
    private authservice : AuthloginService,
    private submitdataservice : SubmitdataService,
    public utils : UtilsModule,
  ) { }

  ngOnInit() {
    this.userdetails = this.authservice.checkloginstatus();
    if(this.userdetails){
      this.districtEntityName =  this.userdetails['loggedUserData']['userProfile']['associatedlocationsDetails'][0];
    }
    this.getuserdetails();
  }
  closeModal(){
    this.activeModal.dismiss('cancel click');
  }
  profileFormSubmit(){
  if(this.basicValidation()){
  let postdata = {
    
    "username" : this.userData['name'],
    "mobileNo" : this.userData['mobilenum'],
    "email" :this.userData['email'],
    "view": "admin",
    "lu" : this.userdetails['loggedUserData']['userProfile']['associatedlocationsDetails'][0]['entityUUID'],
    "cType": "DISTRICT"
  }
  this.submitdataservice.profileDataSubmit(postdata).subscribe(result =>{
     if(result.status){
       this.toastrService.success(result.msg);
       this.activeModal.close();
     } else{
      this.toastrService.error(result.msg);
     }
  });
}
  }
  getuserdetails(){
    let postdata = {
      "view": "admin",
      "lu" : this.userdetails['loggedUserData']['userProfile']['associatedlocationsDetails'][0]['entityUUID'],
      "cType": "DISTRICT"
    }
    this.submitdataservice.getprofileData(postdata).subscribe(result =>{
      if(!isNullOrUndefined(result)){
        Object.keys(result).forEach(data =>{
          Object.keys(result[data]).forEach(value =>{
            this.userData['mobilenum'] = result[data][value]['mobileNumber'];
            this.userData['name'] = result[data][value]['userName'];
            this.userData['email'] = result[data][value]['emailId'];
            
          })
        })
      }
    })
  }
  mandatoryChecks(){
    // for(let i=0;i<this.smallRiverList.length;i++){
      if(isNullOrUndefined(this.userData['email']) || this.userData['email'] === ''){
        this.status[('email_')] = true;
        return false;
      } else if(isNullOrUndefined(this.userData['name']) || this.userData['name'] === ''){
        this.status[('name_')] = true;
        return false;
      }
    return true; 
    }
  validateEmail(email){
    let reg = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
    // var address = document.getElementById[email].value;
    if (reg.test(email) == false){
      this.toastrService.error("Please Enter Valid Email");
      return false;
    } else{
      return true;
    }
    }
    keyPress(event: any) {
      const pattern = /[0-9\+\-\ ]/;
  
      let inputChar = String.fromCharCode(event.charCode);
      if (event.keyCode != 8 && !pattern.test(inputChar)) {
        event.preventDefault();
      }
    }
  basicValidation(){
    if(this.utils.checkfield(this.userData['name'])){
      this.validation['name'] = true;
    }else{
      this.validation['name'] = false;
    }
    if(this.utils.checkfield(this.userData['email'])){
      this.validation['email'] = true;
    }else{
      this.validation['email'] = false;
    }
    // if(this.utils.checkfield(this.userData['mobilenum'])){
    //   this.validation['mobilenum'] = true;
    // }else{
    //   this.validation['mobilenum'] = false;
    // }
    return this.validation['name']  && this.validation['email'];
  } 

}